import systemConfig from '../../../../config/systematic';
import { Button, Checkbox, Col, DatePicker, Form, Input, Row, Select, Space, Table } from 'antd';
import React, { useEffect, useContext, useState, useRef } from 'react'
import getList from '../../../universal/getList';
import fetchApi from '../../../../utils/api/fetchApi';
import dayjs from 'dayjs';
import antMessage from '../../../../utils/extend/AntdNotification'
import DownloadExcel from '../../../report/DownloadExcel';
import { showCustomNotification, useNotificationInstance } from '../../../../utils/extend/AntdNotificationEx';
import { SocketContext } from '../../../../App';

import entrepotPrint from '../../../../generalMethod/entrepotPrint';


const { RangePicker } = DatePicker;

export default function EnPurStatistics() {
  const initialValues: any = {
    chooseTime: [dayjs(), dayjs()],
  };
  const [entrepotData, setEntrepotData] = useState<Array<any>>([]);

  /** 后端数据wmService */
  let wmService: any = systemConfig.wmService;
  const [form] = Form.useForm();

  const [user, setUser] = useState<any>("")
  const [deptData, setDeptData] = useState<any>();
  const [buyerData, setBuyerData] = useState<any>()
  const [classificationWarehouseData, setClassificationWarehouseData] = useState<any>();
  const [queryCriteria, setQueryCriteria] = useState<any>("")
  const notificationApi = useNotificationInstance()
  const useContextData = useContext(SocketContext);
  const [isLoading, setIsLoading] = useState<boolean>(false)
  const [deptName, setDeptName] = useState<string>("");
  const [buyerName, setBuyerName] = useState<string>("");


  const { contextData, setContextData } = useContextData;
  const [entrepotName, setEntrepotName] = useState<string>();

  const [rows, setRows] = useState<any>([]);
  const contentRef = useRef<any>(null);

  const [sortOrder, setSortOrder] = useState<Array<any>>([
    { id: "ASC", name: "升序" },
    { id: "DESC", name: "降序" },

  ])
  const [sortType, setSortType] = useState<Array<any>>([
    { id: "selfId", name: "品号" },
    { id: "classificationWarehouseName", name: "分类" },
    { id: "productName", name: "品名" },


  ]);

  const [productModel, setProductModel] = useState<any>([
    { id: "rangeNumSearch", name: "品号范围搜索" },
    { id: "similarNumSearch", name: "品号相似搜索" },
    { id: "equalNumSearch", name: "品号相等搜索" },
    { id: "similarNameSearch", name: "品名相似搜索" },
    { id: "equalNameSearch", name: "品名相等搜索" },
  ])
  const [dataTypeData, setDataTypeData] = useState<Array<any>>();
  const [selectProdutModel, setSelectProdutModel] = useState<any>("rangeNumSearch")
  useEffect(() => {
    const fetchData = async () => {
      let deptData = await fetchApi.GET(wmService, {
        apiId: "dept",
        apiExtend: 'showList',
        apiData: {

        }
      })
      if (deptData.success) {
        setDeptData(deptData.data)
      }

      let buyerData = await fetchApi.GET(wmService, {
        apiId: "buyer",
        apiExtend: 'showList'
      })

      if (buyerData.success) {
        setBuyerData(buyerData.data)
      }

      let classificationWarehouseData = await fetchApi.GET(wmService, {
        apiId: "classificationWarehouse",
        apiExtend: 'showList'
      })

      if (classificationWarehouseData.success) {
        setClassificationWarehouseData(classificationWarehouseData.data)
      }
      fetchApi.GET(wmService,
        {
          apiId: 'generalData',
          apiVariable: 'dataStatusType',
          apiExtend: 'showLists'
        }
      ).then(res => {
        if (res.success) {
          const { dataStatusType } = res.data


          setDataTypeData(dataStatusType)
        }
      })

      fetchApi.GET(wmService, {
        apiId: 'entrepot',
        apiExtend: 'showListEx',
        apiData: {
          mountDataOptions: {
            userMount: {
              // isEmployees: true,
              // isDept:true,
              isUserEntrepots: true
            }
          },
        }
      }).then((res) => {
        if (res.success) {
          setEntrepotData(res.data)
        }
      })

      // 
    }
    fetchData()
  }, [])
  /** 表头内容 */
  let columnsHead: any = [
    {
      title: "品号",
      dataIndex: "selfId",
    },
    {
      title: "品名",
      dataIndex: "productName",
    },
    {
      title: "分类",
      dataIndex: "classificationWarehouseName",
    },
    {
      title: "单位",
      dataIndex: "productUnitName",
    },

    {
      title: "数量",
      dataIndex: "bNum",
    },
    {
      title: "均价",
      dataIndex: "univalence",
    },
    {
      title: "金额",
      dataIndex: "amount",
    },


  ]
  const onFinish = () => {
    setIsLoading(true)
    form.validateFields()
      .then(async (values: any) => {


        fetchApi.GET(wmService, {
          apiId: "entrepotReport",
          apiExtend: 'enPurStatistics',
          apiData: {
            ...values,
            time: values.chooseTime ? {
              startTime: dayjs(values.chooseTime[0]).format("YYYY-MM-DD"),
              endTime: dayjs(values.chooseTime[1]).format("YYYY-MM-DD"),
            } : null,
            entrepotId: contextData?.currentEntrepotId,
            selfs: values.selfStart && values.selfEnd ? {
              selfStart: values.selfStart,
              selfEnd: values.selfEnd
            } : null,
            productModel: values.productModel,
            // mountDataOptions:{
            //   userMount: {
            //       isEmployees: true,
            //       isDept:true,
            //       isUserAreas:true
            //   }
            //  },
          }
          // classificationWarehouseId
        }).then((res: any) => {
          setIsLoading(false)
          setRows(res.data.rows)
          setQueryCriteria(res.data.queryCriteria)
          setUser(res.data.user)
          showCustomNotification(notificationApi!, {
            type: 'success',
            message: "搜索成功",
            description: "success"
          });;

        }).catch((err: any) => {
          console.log("err", err);
          setIsLoading(false)
          antMessage('error', '搜索失败', err.message + ' | status：' + err.errors.status);
        })
      })
      .catch((err) => {
        setIsLoading(false)
        showCustomNotification(notificationApi!, {
          type: 'warning',
          message: "无法通过数据校验",
          description: "请输入所需数据!"
        });;
      })





  }
  // 修改后的 handlePrint 配置
  const handlePrint = () => {
    if (rows.length === 0) {
      antMessage('error', '打印失败', "无打印数据");
      return false
    }
    let table = document.getElementsByTagName("table")[0]
    table.border = "1";
    table.style.width = "100%";
    table.style.fontSize = "12px";

    table.cellPadding = "0";
    table.cellSpacing = "0";
    let data = document.getElementById("aa")?.innerHTML;
    entrepotPrint.printEnReportEx(JSON.stringify(data), "exDailyReport")
  }
  const onChangeBranchStore = (e: any) => {
    let checked = e.target.checked;

    if (checked) {
      fetchApi.GET(wmService, {
        apiId: "branchStore",
        apiExtend: 'getDeptByentrepot',
        apiData: {
          entrepotId: contextData?.currentEntrepotId

        }

      }).then((res: any) => {

        if (res.success) {
          let detpName = [];
          let deptId = [];
          if (res.data.length > 0) {
            setDeptData(res.data)
            for (let i = 0; i < res.data.length; i++) {
              detpName.push(res.data[i].deptName);
              deptId.push(res.data[i].id);

            }
            form.setFieldValue("deptIds", deptId)
            setDeptName(detpName.join("|"))

          }


        } else {
          form.setFieldValue("deptIds", [])
        }
      }).catch((err: any) => {
        form.setFieldValue("deptIds", [])
        console.log("err", err);


      })
    } else {
      form.setFieldValue("deptIds", [])
    }

  }
  const changeProductModel = (e: any) => {
    setSelectProdutModel(e)

  }

  const onChangeArea = (e: any) => {
    let checked = e.target.checked;
    let entrepotName: Array<any> = [];
    if (checked) {
      let areaId = localStorage.getItem("currentAreaId")
      let ids: Array<string> = [];
      if (entrepotData.length > 0) {
        entrepotData.forEach((item) => {

          if (item.areaId === areaId) {
            ids.push(item.entrepotId)
            entrepotName.push(item.entrepotName)

          }
        })
      }
      form.setFieldValue("entrepotIds", ids)
      setEntrepotName(entrepotName.join("|"))
    } else {
        setEntrepotName("")
      form.setFieldValue("entrepotIds", [])
    }

  }
  const changeDept = (e: any, option: any) => {
    let deptName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      deptName.push(option[i].children)
    }
    setDeptName(deptName.join("|"))
  }

  const changeEntrepot = (e: any, option: any) => {
    let entrepotName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      entrepotName.push(option[i].children)
    }
    setEntrepotName(entrepotName.join("|"))
  }

  const changeBuyers = (e: any, option: any) => {
    let buyerName: Array<any> = [];
    for (let i = 0; i < option?.length; i++) {
      buyerName.push(option[i].children)
    }
    setBuyerName(buyerName.join("|"))
  }
  return (
    <>
      <Form
        form={form}
        onFinish={onFinish}
        initialValues={{ productModel: "rangeNumSearch", dataStatusType: 1 }}
      >
        <Row>
          <Col span={6}>
            <Form.Item
              label="部门"
              name="deptIds"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="请选择部门!"
                optionFilterProp="children"
                onChange={changeDept}
                onSearch={(e) => getList.search('dept', setDeptData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(deptData, 'deptName')}
              </Select>
            </Form.Item>
          </Col>


          <Col span={6}>
            <Form.Item
              label="采购商"
              name="buyers"
            >
              <Select
                onChange={changeBuyers}
                mode="multiple"
                showSearch
                placeholder="采购商"
                optionFilterProp="children"
                onSearch={(e) => getList.search('buyer', setBuyerData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(buyerData, 'buyerName')}
              </Select>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              label="产品模式"
              name="productModel"

            >
              <Select
                // defaultValue={"rangeNumSearch"}
                onChange={changeProductModel}
                showSearch
                placeholder="产品模式"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(productModel, 'name')}
              </Select>
            </Form.Item>
          </Col>
          {
            selectProdutModel === "rangeNumSearch" ?
              <>
                <Col span={3}>
                  <Form.Item
                    label="品号"
                    name="selfStart"
                  >
                    <Input
                    />
                  </Form.Item>
                </Col>

                <Col span={3}>
                  <Form.Item
                    colon={false}
                    label="-"
                    name="selfEnd"
                  >
                    <Input

                    />
                  </Form.Item>
                </Col>
              </>
              : null
          }

          {
            selectProdutModel === "similarNameSearch" || selectProdutModel === "equalNameSearch" ?
              <>
                <Col span={3}>
                  <Form.Item
                    label="品名"
                    name="productName"
                  >
                    <Input />
                  </Form.Item>
                </Col>

              </>
              : null
          }
          {
            selectProdutModel === "similarNumSearch" || selectProdutModel === "equalNumSearch" ?
              <>
                <Col span={3}>
                  <Form.Item
                    label="品号"
                    name="selfId"
                  >
                    <Input />
                  </Form.Item>
                </Col>

              </>
              : null
          }

          <Col span={4}>
            <Form.Item
              label="品类"
              name="classificationWarehouses"
            >
              <Select
                mode="multiple"
                showSearch
                placeholder="品类"
                optionFilterProp="children"
                onSearch={(e) => getList.search('classificationWarehouse', setClassificationWarehouseData, e)}
                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(classificationWarehouseData, 'classificationWarehouseName')}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="排序类型"
              name="sortType"
            >
              <Select
                showSearch
                placeholder="排序类型"
                optionFilterProp="children"

              >
                {getList.general(sortType)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item
              label="排序方式"
              name="sortOrder"
            >
              <Select
                showSearch
                placeholder="排序方式"
                optionFilterProp="children"

                filterOption={(input, option: any) => {
                  return true
                }}
              >
                {getList.general(sortOrder,)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item
              label="日期"
              name="chooseTime"
              initialValue={initialValues.chooseTime}
            >
              <RangePicker
                // defaultValue={initialValues.chooseTime}
                format="YYYY-MM-DD"
              />
            </Form.Item>
          </Col>
          <Col span={1.5}>
            <Form.Item
              label="当前分店"
              name="isCurrentBranchStore"
              valuePropName="checked"

            >
              <Checkbox onChange={onChangeBranchStore}></Checkbox>
            </Form.Item>
          </Col>

          <Col span={3}>
            <Form.Item
              label="仓库"
              name="entrepotIds"
              tooltip={"选中时，账套切换的仓库数据失效， 只支持选中的仓库数据查询"}
            >
              <Select
               allowClear
                onChange={changeEntrepot}
                mode='multiple'
                placeholder="多仓库"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(entrepotData, "entrepotName", "entrepotId")}
              </Select>
            </Form.Item>
          </Col>

          <Col span={2}>
            <Form.Item
              label="当前区域"
              name="isCurrentArea"
              valuePropName="checked"

            >
              <Checkbox onChange={onChangeArea}></Checkbox>
            </Form.Item>
          </Col>
          <Col span={3}>
            <Form.Item
              name="dataStatusType"
            >
              <Select
                defaultValue="数据状态"
                placeholder="数据状态"
                optionFilterProp="children"
                filterOption={(input, option: any) =>
                  option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0}>
                {getList.general(dataTypeData)}
              </Select>
            </Form.Item>
          </Col>
          <Col span={4}>
            <Form.Item >
              <Space>
                <Button loading={isLoading} htmlType="submit">
                  统计
                </Button >
                <Button onClick={handlePrint}>打印</Button>
                <Button onClick={() => DownloadExcel(rows, "enPurStatistics", { ...queryCriteria, deptName, buyerName, entrepotName })}>下载EXCEL文件</Button>
                {/* <Button onClick={() => entrepotPrint.printEnReport(rows, "entrepotDailyReportPrint", queryCriteria, user)} >
                  打印
                </Button> */}
              </Space>
            </Form.Item>
          </Col>
        </Row>
      </Form>

      <div id='aa' ref={contentRef} style={{ marginTop: "20px" }}>
        <div style={{ fontSize: 20, textAlign: "center", marginBottom: 10 }}>收货统计表</div>
        <div style={{ fontSize: 16, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
          <div>时间:{queryCriteria.date}</div>
          {/* <div>部门：{queryCriteria.deptName}</div> */}
          <div>分类:{queryCriteria.classificationWarehouses}</div>

          <div>采购商:{buyerName}</div>
        </div>

        <div style={{ fontSize: 14, textAlign: "center", marginBottom: 10, display: "flex", justifyContent: "space-between", }}>
          <div>{deptName ? `部门：${deptName}` : ""}</div>
          <div>{entrepotName ? `仓库：${entrepotName}` : ""}</div>
          <div>品号:{queryCriteria.selfs}</div>
        </div>
        <Table
          // scroll={{ x: "100%", y: 650 }}
          pagination={false}
          rowKey={(record: any, index: any) => {
            return index
          }}
          columns={columnsHead}
          dataSource={rows}

        >
        </Table>

      </div>
    </>
  )
}
